/**
 * District/Organization specific endpoints
 */
import { client } from '../lib/http-client';

function unwrap<T>(result: { data?: T; error?: unknown }): T {
  if (result.error !== undefined) {
    throw result.error;
  }
  return result.data as T;
}

export interface AdministrativeLocationItem {
  code: string;
  name: string;
}

export interface AdministrativeLocationResponse {
  country: { code: string; name: string };
  results: { type: string; count: number; items: AdministrativeLocationItem[] };
}

export async function getAreaLocationDetails(
  country?: string | null,
): Promise<AdministrativeLocationResponse> {
  const result = await client.GET('/api/v2/administrative-locations/' as any, {
    params: { query: { country: country ?? undefined } as never },
  });
  return unwrap(result) as unknown as AdministrativeLocationResponse;
}
